import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs,deleteDoc, doc } from "firebase/firestore";
import { db, auth } from "../../firebase";
import { Link } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import Modal from "../../components/Modal"; // pad aanpassen indien nodig

const PropertyList = () => {
    const [properties, setProperties] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedPropertyId, setSelectedPropertyId] = useState(null);
    const [showModal, setShowModal] = useState(false)

    const deletePropertyWithSlots = async (propertyId) => {
        try {
            const slotsRef = collection(db, "properties", propertyId, "timeslots");
            const slotSnaps = await getDocs(slotsRef);
            const deleteSlots = slotSnaps.docs.map((docSnap) =>
                deleteDoc(doc(db, "properties", propertyId, "timeslots", docSnap.id))
            );
            await Promise.all(deleteSlots);
            await deleteDoc(doc(db, "properties", propertyId));
            alert("Woning verwijderd ✅");
            setShowModal(false);
            setProperties(properties.filter((p) => p.id !== propertyId));
        } catch (err) {
            console.error(err);
            alert("Fout bij verwijderen");
        }
    };

    useEffect(() => {
        const fetchProperties = async () => {
            const user = auth.currentUser;
            if (!user) return;

            const q = query(
                collection(db, "properties"),
                where("userId", "==", user.uid)
            );

            const querySnapshot = await getDocs(q);
            const data = querySnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));

            setProperties(data);
            setLoading(false);
        };

        fetchProperties();
    }, []);

    return (
        <DashboardLayout>
            <div className="max-w-4xl mx-auto">
                <h2 className="text-2xl font-semibold mb-4">Mijn woningen</h2>

                {loading ? (
                    <p>Woningen laden...</p>
                ) : properties.length === 0 ? (
                    <p>Je hebt nog geen woningen toegevoegd.</p>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {properties.map((property) => (
                            <div
                                key={property.id}
                                className="bg-white rounded shadow p-4 border border-gray-100 flex justify-between gap-4"
                            >
                                {/* Linkerkant: tekst en knoppen */}
                                <div className="flex-1">
                                    <h3 className="text-lg font-semibold">{property.title}</h3>
                                    <p className="text-sm text-gray-500">{property.address}</p>
                                    <p className="text-sm text-gray-600 mt-1">{property.description}</p>

                                    <div className="mt-4 space-y-2">
                                        <Link
                                            to={`/dashboard/properties/${property.id}/timeslots`}
                                            className="block text-sm text-blue-600 hover:underline"
                                        >
                                            Tijdsloten beheren →
                                        </Link>

                                        <button
                                            onClick={() =>
                                                navigator.clipboard
                                                    .writeText(`${window.location.origin}/property/${property.id}/boek`)
                                                    .then(() => alert("Publieke link gekopieerd naar klembord!"))
                                            }
                                            className="block text-sm text-gray-600 hover:text-blue-600"
                                        >
                                            📤 Deel link
                                        </button>

                                        <details className="text-sm text-gray-500 mt-1 select-all">
                                            <summary className="cursor-pointer hover:text-blue-600">
                                                Embed iframe tonen
                                            </summary>
                                            <code className="block bg-gray-100 p-2 rounded mt-1 text-xs break-all">
                                                {`<iframe src="${window.location.origin}/property/${property.id}/boek" width="100%" height="800" style="border: none;"></iframe>`}
                                            </code>
                                        </details>
                                        <button
                                            onClick={() => {
                                                setSelectedPropertyId(property.id);
                                                setShowModal(true);
                                            }}
                                            className="text-red-600 text-sm hover:underline mt-2"
                                        >
                                            🗑 Verwijder woning
                                        </button>
                                    </div>
                                </div>

                                {/* Rechterkant: woningfoto */}
                                {property.woningFotoUrl && (
                                    <div className="w-24 h-24 flex-shrink-0">
                                        <img
                                            src={property.woningFotoUrl}
                                            alt="Woning"
                                            className="w-full h-full object-cover rounded"
                                        />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <Modal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                onConfirm={() => deletePropertyWithSlots(selectedPropertyId)}
                title="Weet je zeker dat je deze woning wilt verwijderen?"
                description="Alle bijbehorende tijdsloten worden ook permanent verwijderd. Deze actie kan niet ongedaan worden gemaakt."
            />
        </DashboardLayout>
    );
};

export default PropertyList;
